module.exports = __webpack_public_path__ + "images/Thumbs up - fill544917fee5ee8bbec89f6868449f9be3.svg";